import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaHome, FaBed, FaCalendarAlt, FaTools, FaChartBar, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { auth, db } from '../../../firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import './index.css';

const Sidebar = ({ onUserLoaded }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const userRef = doc(db, 'users', currentUser.uid);
          const userDoc = await getDoc(userRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            const role = userData.role;
            if (role === 'owner') {
              setUser(currentUser);
              setUserEmail(userData.email || '');
              // Pass ownerId to parent component
              onUserLoaded?.({ ownerId: currentUser.uid });
            } else {
              console.log('Non-owner role detected, signing out');
              await signOut(auth);
              navigate('/');
            }
          } else {
            console.log('No user document found');
            await signOut(auth);
            navigate('/');
          }
        } catch (error) {
          console.error('Error checking user role:', error);
          await signOut(auth);
          navigate('/');
        }
      } else {
        setUser(null);
        navigate('/');
      }
    });

    return () => unsubscribe();
  }, [navigate, onUserLoaded]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="avatar">LU</div>
        <h4>{userEmail}</h4>
      </div>
      <ul className="sidebar-menu">
        <li>
          <NavLink to="/owner-dashboard" end className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaHome /> Owner Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/owner-dashboard/villas" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaBed /> My Villas
          </NavLink>
        </li>
        <li>
          <NavLink to="/owner-dashboard/bookings" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaCalendarAlt /> Bookings
          </NavLink>
        </li>
        <li>
          <NavLink to="/owner-dashboard/services" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaTools /> Service Requests
          </NavLink>
        </li>
        <li>
          <NavLink to="/owner-dashboard/finance" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaChartBar /> Finance Analytics
          </NavLink>
        </li>
        <li>
          <NavLink to="/owner-dashboard/settings" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaCog /> Settings
          </NavLink>
        </li>
      </ul>
       <NavLink to="/" className="mb-3 mt-3" style={{ textDecoration: 'none', color: 'inherit' }}>
          <FaHome /> Back to Home
        </NavLink>
      <div className="logout" onClick={handleLogout}>
        <FaSignOutAlt /> Log out
      </div>
    </div>
  );
};

export default Sidebar;